// User waypoint symbology — flag/diamond marker registered via ensureSvgImages.
// Mirrors fixIcons.ts pattern. Uses Fyrefly's ember-400 tint (#fb923c)
// so user waypoints stand out as user-created rather than chart features.

import type { Map as MlMap } from 'maplibre-gl';
import { ensureSvgImages } from './iconRegistry';

const SIZE = 20;
const EMBER_400 = '#fb923c';  // ember-400 (Fyrefly accent)
const HALO = '#0b0d0f';

/**
 * Diamond flag icon — a filled diamond shape matching a "custom pin"
 * convention. Lucide's Flag icon is too complex to inline accurately
 * as an SVG string; a diamond is the standard EFB custom-waypoint
 * glyph (Garmin, ForeFlight both use it) and renders crisply at 20px.
 */
function svgWptFlag(): string {
  const cx = SIZE / 2;
  const cy = SIZE / 2;
  const r = 7;
  // Diamond: top, right, bottom, left
  const points = [
    `${cx},${cy - r}`,          // top
    `${cx + r * 0.65},${cy}`,   // right
    `${cx},${cy + r}`,          // bottom
    `${cx - r * 0.65},${cy}`,   // left
  ].join(' ');
  return `
    <svg xmlns="http://www.w3.org/2000/svg" width="${SIZE}" height="${SIZE}" viewBox="0 0 ${SIZE} ${SIZE}">
      <polygon points="${points}"
               fill="${HALO}" stroke="${HALO}" stroke-width="3" stroke-linejoin="round"/>
      <polygon points="${points}"
               fill="${EMBER_400}" stroke="${EMBER_400}" stroke-width="1.2" stroke-linejoin="round"/>
    </svg>
  `;
}

export const WPT_FLAG_LEGEND_SVG = svgWptFlag();

export function ensureUserWaypointIcons(map: MlMap): Promise<void> {
  return ensureSvgImages(
    map,
    [{ id: 'wpt-flag', svg: svgWptFlag() }],
    { defaultSize: SIZE, logTag: '[userWaypointIcons]' },
  );
}
